import { useBaseModules } from '@bonusly/common-action-input';
import { useCurrentCompany, useCurrentUser } from '@bonusly/who-am-i';

// This hook is used to determine which modules are available to the user when giving peer to peer.
// It combines the default options with any overrides provided by the caller.
export const usePeerToPeerModules = (
	overrides: Parameters<typeof useBaseModules>[0] = {
		includeEmoji: true,
		includeHashtag: true,
		includeLink: true,
		includeMention: true,
		includeAmount: true,
		includePrivacy: true,
		includeGif: true,
		includeVideoRecording: true,
		includeAudioRecording: true,
		includeAttachment: true,
		includeRecipient: true,
	}
) => {
	const user = useCurrentUser();
	const company = useCurrentCompany();
	const includeAmount = user.can_give_non_zero && !(company.zero_point_bonuses && user.giving_balance === 0);
	const includePrivacy = company.bonus_privacy;

	const defaultOptions = {
		includeEmoji: true,
		includeHashtag: true,
		includeLink: true,
		includeMention: true,
		includeAmount,
		includePrivacy,
		includeGif: true,
		includeVideoRecording: true,
		includeAudioRecording: true,
		includeAttachment: true,
		includeRecipient: true,
	};

	// Combine defaults with overrides using logical AND
	const combinedOptions = {
		includeEmoji: defaultOptions.includeEmoji && overrides.includeEmoji,
		includeHashtag: defaultOptions.includeHashtag && overrides.includeHashtag,
		includeLink: defaultOptions.includeLink && overrides.includeLink,
		includeMention: defaultOptions.includeMention && overrides.includeMention,
		includeAmount: defaultOptions.includeAmount && overrides.includeAmount,
		includePrivacy: defaultOptions.includePrivacy && overrides.includePrivacy,
		includeGif: defaultOptions.includeGif && overrides.includeGif,
		includeVideoRecording: defaultOptions.includeVideoRecording && overrides.includeVideoRecording,
		includeAudioRecording: defaultOptions.includeAudioRecording && overrides.includeAudioRecording,
		includeAttachment: defaultOptions.includeAttachment && overrides.includeAttachment,
		includeRecipient: defaultOptions.includeRecipient && overrides.includeRecipient,
	};

	return useBaseModules(combinedOptions);
};
